import { SystemStyleObject } from "@chakra-ui/react";

export const marketoStyles: SystemStyleObject = {
  ".mktoForm": {
    width: "100% !important",
    fontFamily: "inherit !important",
    display: "flex !important",
    flexWrap: "wrap !important",
    justifyContent: "space-between !important",
  },
  ".mktoFormRow": {
    width: "100% !important",
    marginBottom: "16px !important",
    clear: "both !important",
    "@media (min-width: 768px)": {
      width: "calc(50% - 8px) !important",
    },
  },
  ".mktoFormRow.row-textarea, .mktoFormRow.row-checkbox": {
    "@media (min-width: 768px)": {
      width: "100% !important",
    },
  },
  ".mktoButtonRow": {
    width: "100% !important",
    display: "flex !important",
    justifyContent: "center !important",
    marginTop: "8px !important",
  },
  ".mktoFormCol": {
    width: "100% !important",
    marginBottom: "0 !important",
  },
  ".mktoFieldWrap": { width: "100% !important", position: "relative" },
  ".mktoAsterix": { display: "none !important" },
  ".mktoLabel": {
    display: "block !important",
    width: "auto !important",
    float: "none !important",
    minHeight: "0 !important",
    padding: "0 !important",
    margin: "0 !important",
    fontWeight: "500 !important",
    color: "var(--chakra-colors-text-primary) !important",
  },
  "input[type='checkbox'] ~ label, .mktoLogicalField label": {
    fontWeight: "normal !important",
    fontSize: "14px !important",
    lineHeight: "1.5 !important",
    color: "var(--chakra-colors-text-secondary, #4A5568) !important",
    cursor: "pointer",
  },
  ".mktoForm a": {
    color: "var(--chakra-colors-accounting-green-800, #0F5F35) !important",
    textDecoration: "underline !important",
    fontWeight: "600 !important",
    display: "inline-block !important",
    padding: "4px !important",
    margin: "-4px !important",
    position: "relative",
    zIndex: 10,
  },
  ".mktoField:not([type='checkbox']):not([type='radio'])": {
    width: "100% !important",
    padding: "16px 20px !important",
    border: "1px solid var(--chakra-colors-border-primary, #E2E8F0) !important",
    borderRadius: "8px !important",
    backgroundColor: "var(--chakra-colors-bg-input, #F7FAFC) !important",
    color: "var(--chakra-colors-text-primary, #1A202C) !important",
    fontSize: "16px !important",
    lineHeight: "1.5 !important",
    transition: "all 0.2s !important",
    boxSizing: "border-box !important",
  },
  ".mktoField:not([type='checkbox']):not([type='radio']):focus": {
    borderColor: "var(--chakra-colors-btn-green-bg, #0F5F35) !important",
    boxShadow: "0 0 0 1px var(--chakra-colors-btn-green-bg, #0F5F35) !important",
    outline: "none !important",
    backgroundColor: "white !important",
  },
  "textarea.mktoField": {
    minHeight: "120px !important",
    resize: "vertical !important",
  },
  ".mktoButtonWrap": { marginLeft: "0 !important" },
  ".mktoButton": {
    background: "var(--chakra-colors-accounting-green-800, #0F5F35) !important",
    color: "white !important",
    border: "none !important",
    padding: "16px 32px !important",
    borderRadius: "9999px !important",
    fontSize: "16px !important",
    fontWeight: "bold !important",
    cursor: "pointer !important",
    transition: "background-color 0.2s !important",
    width: "100% !important",
    "@media (min-width: 768px)": {
      width: "auto !important",
      minWidth: "200px !important",
    },
  },
  ".mktoButton:hover": {
    background: "var(--chakra-colors-accounting-green-950, #003725) !important",
  },
  ".mktoLogicalField, .mktoCheckboxList": {
    display: "flex !important",
    alignItems: "flex-start !important",
    gap: "12px !important",
    width: "100% !important",
    marginTop: "-6px !important",
  },
  "input[type='checkbox']": {
    minWidth: "18px !important",
    height: "18px !important",
    cursor: "pointer",
    marginTop: "0px !important",
  },
  ".mktoOffset, .mktoClear, .mktoGutter": { display: "none !important" },
};
